module.exports = __webpack_public_path__ + "img/nebl.2ccea441.svg";